import type { JWTContextType } from '../../types';

import { createContext } from 'react';

// ----------------------------------------------------------------------

export const AuthContext = createContext({} as JWTContextType);
